/* tslint:disable */
/* eslint-disable */
/**
 * V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var ClientChannel;
(function (ClientChannel) {
    ClientChannel["App"] = "app";
    ClientChannel["Web"] = "web";
})(ClientChannel || (ClientChannel = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SuspensionStatus;
(function (SuspensionStatus) {
    SuspensionStatus["NotSuspended"] = "notSuspended";
    SuspensionStatus["SoftSuspended"] = "softSuspended";
    SuspensionStatus["HardSuspended"] = "hardSuspended";
})(SuspensionStatus || (SuspensionStatus = {}));
/**
 * AdminUsersApi - axios parameter creator
 * @export
 */
export const AdminUsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [admin] Paginated list endpoint for showing (and eventually filtering among) all users  in the database.
         * @param {string} xPlatformKey2 Select the platform.
         * @param {string} [xPlatformKey]
         * @param {string} [searchTerm]
         * @param {string} [userTier]
         * @param {string} [rolesIds]
         * @param {number} [offset]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersGet: (xPlatformKey2, xPlatformKey, searchTerm, userTier, rolesIds, offset, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey2' is not null or undefined
            assertParamExists('adminUsersGet', 'xPlatformKey2', xPlatformKey2);
            const localVarPath = `/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (userTier !== undefined) {
                localVarQueryParameter['userTier'] = userTier;
            }
            if (rolesIds !== undefined) {
                localVarQueryParameter['rolesIds'] = rolesIds;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            if (xPlatformKey2 != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey2);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Provides details for the users in a list
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [userIds]
         * @param {boolean} [ignorePlatformScope]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersListGet: (xPlatformKey, userIds, ignorePlatformScope, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminUsersListGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/users/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (userIds !== undefined) {
                localVarQueryParameter['userIds'] = userIds;
            }
            if (ignorePlatformScope !== undefined) {
                localVarQueryParameter['ignorePlatformScope'] = ignorePlatformScope;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdDelete: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdDelete', 'userId', userId);
            const localVarPath = `/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Update user email and/or phone number (also updates on finance-service)  <param name=\"userId\">The user ID.</param><param name=\"request\">The email address and phone number. </param><param name=\"_\">A Cancellation token.</param>
         * @param {string} userId
         * @param {AdminUsersUserIdEmailPhonePatchRequest} [adminUsersUserIdEmailPhonePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdEmailPhonePatch: (userId, adminUsersUserIdEmailPhonePatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdEmailPhonePatch', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/email-phone`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminUsersUserIdEmailPhonePatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This is the admin endpoint for fetching a user\'s details. Returns 404 if the user is not found.  The returned DTO contains more details about the user than the list item DTO.
         * @summary [Admin] Provides details about a single user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdGet: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdGet', 'userId', userId);
            const localVarPath = `/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] toggle the marketing opt-in for a user  <param name=\"_\">A Cancellation token.</param>
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdMarketingTogglePost: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdMarketingTogglePost', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/marketing/toggle`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Send a password reset email to a user  <param name=\"force\">Force the user to reset its password</param><param name=\"_\">A Cancellation token.</param>
         * @param {string} userId
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdPasswordResetPost: (userId, force, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdPasswordResetPost', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/password/reset`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Updates the user identified by {userId} to have the specified roles.
         * @param {string} userId
         * @param {AdminUsersUserIdRolesPutRequest} [adminUsersUserIdRolesPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdRolesPut: (userId, adminUsersUserIdRolesPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdRolesPut', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/roles`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminUsersUserIdRolesPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Creates a new admin session for the specified user, returning an access- and refresh token  that can be used by the frontend to impersonate the specified user.
         * @summary Creates a new (admin) session for the specified user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdSessionsPost: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdSessionsPost', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/sessions`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Update the user\'s suspension status
         * @param {string} userId
         * @param {'NotSuspended' | 'SoftSuspended' | 'HardSuspended'} [suspensionStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdSuspensionStatusPut: (userId, suspensionStatus, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdSuspensionStatusPut', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/suspension-status`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (suspensionStatus !== undefined) {
                localVarQueryParameter['suspensionStatus'] = suspensionStatus;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Finds the user and block them from placing new bids
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierBidBlockPut: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdTierBidBlockPut', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/tier/bid-block`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Finds the user and allow them to place new bids again
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierBidUnblockPut: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdTierBidUnblockPut', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/tier/bid-unblock`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s verification status to \"suspended\", which will block the user from logging in
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierSuspendedPut: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdTierSuspendedPut', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/tier/suspended`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s verification status back to their status before being suspended
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierUnsuspendedPut: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdTierUnsuspendedPut', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/tier/unsuspended`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sets a user\'s payment verification status to verified
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdVerificationPaymentVerifiedPatch: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdVerificationPaymentVerifiedPatch', 'userId', userId);
            const localVarPath = `/admin/users/{userId}/verification/payment/verified`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminUsersApi - functional programming interface
 * @export
 */
export const AdminUsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminUsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [admin] Paginated list endpoint for showing (and eventually filtering among) all users  in the database.
         * @param {string} xPlatformKey2 Select the platform.
         * @param {string} [xPlatformKey]
         * @param {string} [searchTerm]
         * @param {string} [userTier]
         * @param {string} [rolesIds]
         * @param {number} [offset]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersGet(xPlatformKey2, xPlatformKey, searchTerm, userTier, rolesIds, offset, size, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersGet(xPlatformKey2, xPlatformKey, searchTerm, userTier, rolesIds, offset, size, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Provides details for the users in a list
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [userIds]
         * @param {boolean} [ignorePlatformScope]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersListGet(xPlatformKey, userIds, ignorePlatformScope, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersListGet(xPlatformKey, userIds, ignorePlatformScope, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdDelete(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdDelete(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Update user email and/or phone number (also updates on finance-service)  <param name=\"userId\">The user ID.</param><param name=\"request\">The email address and phone number. </param><param name=\"_\">A Cancellation token.</param>
         * @param {string} userId
         * @param {AdminUsersUserIdEmailPhonePatchRequest} [adminUsersUserIdEmailPhonePatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdEmailPhonePatch(userId, adminUsersUserIdEmailPhonePatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdEmailPhonePatch(userId, adminUsersUserIdEmailPhonePatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This is the admin endpoint for fetching a user\'s details. Returns 404 if the user is not found.  The returned DTO contains more details about the user than the list item DTO.
         * @summary [Admin] Provides details about a single user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdGet(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdGet(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] toggle the marketing opt-in for a user  <param name=\"_\">A Cancellation token.</param>
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdMarketingTogglePost(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdMarketingTogglePost(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Send a password reset email to a user  <param name=\"force\">Force the user to reset its password</param><param name=\"_\">A Cancellation token.</param>
         * @param {string} userId
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdPasswordResetPost(userId, force, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdPasswordResetPost(userId, force, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Updates the user identified by {userId} to have the specified roles.
         * @param {string} userId
         * @param {AdminUsersUserIdRolesPutRequest} [adminUsersUserIdRolesPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdRolesPut(userId, adminUsersUserIdRolesPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdRolesPut(userId, adminUsersUserIdRolesPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Creates a new admin session for the specified user, returning an access- and refresh token  that can be used by the frontend to impersonate the specified user.
         * @summary Creates a new (admin) session for the specified user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdSessionsPost(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdSessionsPost(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Update the user\'s suspension status
         * @param {string} userId
         * @param {'NotSuspended' | 'SoftSuspended' | 'HardSuspended'} [suspensionStatus]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdSuspensionStatusPut(userId, suspensionStatus, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdSuspensionStatusPut(userId, suspensionStatus, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Finds the user and block them from placing new bids
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierBidBlockPut(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdTierBidBlockPut(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Finds the user and allow them to place new bids again
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierBidUnblockPut(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdTierBidUnblockPut(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s verification status to \"suspended\", which will block the user from logging in
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierSuspendedPut(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdTierSuspendedPut(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s verification status back to their status before being suspended
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierUnsuspendedPut(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdTierUnsuspendedPut(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Sets a user\'s payment verification status to verified
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdVerificationPaymentVerifiedPatch(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdVerificationPaymentVerifiedPatch(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminUsersApi - factory interface
 * @export
 */
export const AdminUsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminUsersApiFp(configuration);
    return {
        /**
         *
         * @summary [admin] Paginated list endpoint for showing (and eventually filtering among) all users  in the database.
         * @param {AdminUsersApiAdminUsersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersGet(requestParameters, options) {
            return localVarFp.adminUsersGet(requestParameters.xPlatformKey2, requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.userTier, requestParameters.rolesIds, requestParameters.offset, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Provides details for the users in a list
         * @param {AdminUsersApiAdminUsersListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersListGet(requestParameters, options) {
            return localVarFp.adminUsersListGet(requestParameters.xPlatformKey, requestParameters.userIds, requestParameters.ignorePlatformScope, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
         * @param {AdminUsersApiAdminUsersUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdDelete(requestParameters, options) {
            return localVarFp.adminUsersUserIdDelete(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Update user email and/or phone number (also updates on finance-service)  <param name=\"userId\">The user ID.</param><param name=\"request\">The email address and phone number. </param><param name=\"_\">A Cancellation token.</param>
         * @param {AdminUsersApiAdminUsersUserIdEmailPhonePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdEmailPhonePatch(requestParameters, options) {
            return localVarFp.adminUsersUserIdEmailPhonePatch(requestParameters.userId, requestParameters.adminUsersUserIdEmailPhonePatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This is the admin endpoint for fetching a user\'s details. Returns 404 if the user is not found.  The returned DTO contains more details about the user than the list item DTO.
         * @summary [Admin] Provides details about a single user
         * @param {AdminUsersApiAdminUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdGet(requestParameters, options) {
            return localVarFp.adminUsersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] toggle the marketing opt-in for a user  <param name=\"_\">A Cancellation token.</param>
         * @param {AdminUsersApiAdminUsersUserIdMarketingTogglePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdMarketingTogglePost(requestParameters, options) {
            return localVarFp.adminUsersUserIdMarketingTogglePost(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Send a password reset email to a user  <param name=\"force\">Force the user to reset its password</param><param name=\"_\">A Cancellation token.</param>
         * @param {AdminUsersApiAdminUsersUserIdPasswordResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdPasswordResetPost(requestParameters, options) {
            return localVarFp.adminUsersUserIdPasswordResetPost(requestParameters.userId, requestParameters.force, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Updates the user identified by {userId} to have the specified roles.
         * @param {AdminUsersApiAdminUsersUserIdRolesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdRolesPut(requestParameters, options) {
            return localVarFp.adminUsersUserIdRolesPut(requestParameters.userId, requestParameters.adminUsersUserIdRolesPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new admin session for the specified user, returning an access- and refresh token  that can be used by the frontend to impersonate the specified user.
         * @summary Creates a new (admin) session for the specified user
         * @param {AdminUsersApiAdminUsersUserIdSessionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdSessionsPost(requestParameters, options) {
            return localVarFp.adminUsersUserIdSessionsPost(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Update the user\'s suspension status
         * @param {AdminUsersApiAdminUsersUserIdSuspensionStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdSuspensionStatusPut(requestParameters, options) {
            return localVarFp.adminUsersUserIdSuspensionStatusPut(requestParameters.userId, requestParameters.suspensionStatus, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Finds the user and block them from placing new bids
         * @param {AdminUsersApiAdminUsersUserIdTierBidBlockPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierBidBlockPut(requestParameters, options) {
            return localVarFp.adminUsersUserIdTierBidBlockPut(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Finds the user and allow them to place new bids again
         * @param {AdminUsersApiAdminUsersUserIdTierBidUnblockPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierBidUnblockPut(requestParameters, options) {
            return localVarFp.adminUsersUserIdTierBidUnblockPut(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s verification status to \"suspended\", which will block the user from logging in
         * @param {AdminUsersApiAdminUsersUserIdTierSuspendedPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierSuspendedPut(requestParameters, options) {
            return localVarFp.adminUsersUserIdTierSuspendedPut(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [admin] Finds the user and sets the user\'s verification status back to their status before being suspended
         * @param {AdminUsersApiAdminUsersUserIdTierUnsuspendedPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdTierUnsuspendedPut(requestParameters, options) {
            return localVarFp.adminUsersUserIdTierUnsuspendedPut(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sets a user\'s payment verification status to verified
         * @param {AdminUsersApiAdminUsersUserIdVerificationPaymentVerifiedPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters, options) {
            return localVarFp.adminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminUsersApi - object-oriented interface
 * @export
 * @class AdminUsersApi
 * @extends {BaseAPI}
 */
export class AdminUsersApi extends BaseAPI {
    /**
     *
     * @summary [admin] Paginated list endpoint for showing (and eventually filtering among) all users  in the database.
     * @param {AdminUsersApiAdminUsersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersGet(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersGet(requestParameters.xPlatformKey2, requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.userTier, requestParameters.rolesIds, requestParameters.offset, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Provides details for the users in a list
     * @param {AdminUsersApiAdminUsersListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersListGet(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersListGet(requestParameters.xPlatformKey, requestParameters.userIds, requestParameters.ignorePlatformScope, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Finds the user and sets the user\'s soft-deleted timestamp to utc now, which will block the user from logging in (but can create new account)
     * @param {AdminUsersApiAdminUsersUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdDelete(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdDelete(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Update user email and/or phone number (also updates on finance-service)  <param name=\"userId\">The user ID.</param><param name=\"request\">The email address and phone number. </param><param name=\"_\">A Cancellation token.</param>
     * @param {AdminUsersApiAdminUsersUserIdEmailPhonePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdEmailPhonePatch(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdEmailPhonePatch(requestParameters.userId, requestParameters.adminUsersUserIdEmailPhonePatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This is the admin endpoint for fetching a user\'s details. Returns 404 if the user is not found.  The returned DTO contains more details about the user than the list item DTO.
     * @summary [Admin] Provides details about a single user
     * @param {AdminUsersApiAdminUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdGet(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] toggle the marketing opt-in for a user  <param name=\"_\">A Cancellation token.</param>
     * @param {AdminUsersApiAdminUsersUserIdMarketingTogglePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdMarketingTogglePost(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdMarketingTogglePost(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Send a password reset email to a user  <param name=\"force\">Force the user to reset its password</param><param name=\"_\">A Cancellation token.</param>
     * @param {AdminUsersApiAdminUsersUserIdPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdPasswordResetPost(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdPasswordResetPost(requestParameters.userId, requestParameters.force, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Updates the user identified by {userId} to have the specified roles.
     * @param {AdminUsersApiAdminUsersUserIdRolesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdRolesPut(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdRolesPut(requestParameters.userId, requestParameters.adminUsersUserIdRolesPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Creates a new admin session for the specified user, returning an access- and refresh token  that can be used by the frontend to impersonate the specified user.
     * @summary Creates a new (admin) session for the specified user
     * @param {AdminUsersApiAdminUsersUserIdSessionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdSessionsPost(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdSessionsPost(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Update the user\'s suspension status
     * @param {AdminUsersApiAdminUsersUserIdSuspensionStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdSuspensionStatusPut(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdSuspensionStatusPut(requestParameters.userId, requestParameters.suspensionStatus, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Finds the user and block them from placing new bids
     * @param {AdminUsersApiAdminUsersUserIdTierBidBlockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdTierBidBlockPut(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdTierBidBlockPut(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Finds the user and allow them to place new bids again
     * @param {AdminUsersApiAdminUsersUserIdTierBidUnblockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdTierBidUnblockPut(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdTierBidUnblockPut(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Finds the user and sets the user\'s verification status to \"suspended\", which will block the user from logging in
     * @param {AdminUsersApiAdminUsersUserIdTierSuspendedPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdTierSuspendedPut(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdTierSuspendedPut(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [admin] Finds the user and sets the user\'s verification status back to their status before being suspended
     * @param {AdminUsersApiAdminUsersUserIdTierUnsuspendedPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdTierUnsuspendedPut(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdTierUnsuspendedPut(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sets a user\'s payment verification status to verified
     * @param {AdminUsersApiAdminUsersUserIdVerificationPaymentVerifiedPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    adminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters, options) {
        return AdminUsersApiFp(this.configuration).adminUsersUserIdVerificationPaymentVerifiedPatch(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CognitoLambdaApi - axios parameter creator
 * @export
 */
export const CognitoLambdaApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {CognitoLambdaCreateAuthChallengePostRequest} [cognitoLambdaCreateAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaCreateAuthChallengePost: (cognitoLambdaCreateAuthChallengePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/create-auth-challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaCreateAuthChallengePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaCustomEmailSenderPostRequest} [cognitoLambdaCustomEmailSenderPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaCustomEmailSenderPost: (cognitoLambdaCustomEmailSenderPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/custom-email-sender`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaCustomEmailSenderPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaDefineAuthChallengePostRequest} [cognitoLambdaDefineAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaDefineAuthChallengePost: (cognitoLambdaDefineAuthChallengePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/define-auth-challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaDefineAuthChallengePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaMigrateUserPostRequest} [cognitoLambdaMigrateUserPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaMigrateUserPost: (cognitoLambdaMigrateUserPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/migrate-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaMigrateUserPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaPostConfirmationPostRequest} [cognitoLambdaPostConfirmationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPostConfirmationPost: (cognitoLambdaPostConfirmationPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/post-confirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaPostConfirmationPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaPreSignUpPostRequest} [cognitoLambdaPreSignUpPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPreSignUpPost: (cognitoLambdaPreSignUpPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/pre-sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaPreSignUpPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaPreTokenGenerationPostRequest} [cognitoLambdaPreTokenGenerationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPreTokenGenerationPost: (cognitoLambdaPreTokenGenerationPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/pre-token-generation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaPreTokenGenerationPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaPreTokenGenerationPostRequest} [cognitoLambdaPreTokenGenerationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaTokenGenerationPost: (cognitoLambdaPreTokenGenerationPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/token-generation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaPreTokenGenerationPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaMigrateUserPostRequest} [cognitoLambdaMigrateUserPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaUserMigrationPost: (cognitoLambdaMigrateUserPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/user-migration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaMigrateUserPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaVerifyAuthChallengePostRequest} [cognitoLambdaVerifyAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaVerifyAuthChallengePost: (cognitoLambdaVerifyAuthChallengePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/verify-auth-challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaVerifyAuthChallengePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {CognitoLambdaVerifyAuthChallengePostRequest} [cognitoLambdaVerifyAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaVerifyAuthChallengeResponsePost: (cognitoLambdaVerifyAuthChallengePostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/cognito/lambda/verify-auth-challenge-response`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cognitoLambdaVerifyAuthChallengePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CognitoLambdaApi - functional programming interface
 * @export
 */
export const CognitoLambdaApiFp = function (configuration) {
    const localVarAxiosParamCreator = CognitoLambdaApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CognitoLambdaCreateAuthChallengePostRequest} [cognitoLambdaCreateAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaCreateAuthChallengePost(cognitoLambdaCreateAuthChallengePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaCreateAuthChallengePost(cognitoLambdaCreateAuthChallengePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaCustomEmailSenderPostRequest} [cognitoLambdaCustomEmailSenderPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaCustomEmailSenderPost(cognitoLambdaCustomEmailSenderPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaCustomEmailSenderPost(cognitoLambdaCustomEmailSenderPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaDefineAuthChallengePostRequest} [cognitoLambdaDefineAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaDefineAuthChallengePost(cognitoLambdaDefineAuthChallengePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaDefineAuthChallengePost(cognitoLambdaDefineAuthChallengePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaMigrateUserPostRequest} [cognitoLambdaMigrateUserPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaMigrateUserPost(cognitoLambdaMigrateUserPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaMigrateUserPost(cognitoLambdaMigrateUserPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaPostConfirmationPostRequest} [cognitoLambdaPostConfirmationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPostConfirmationPost(cognitoLambdaPostConfirmationPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaPostConfirmationPost(cognitoLambdaPostConfirmationPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaPreSignUpPostRequest} [cognitoLambdaPreSignUpPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPreSignUpPost(cognitoLambdaPreSignUpPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaPreSignUpPost(cognitoLambdaPreSignUpPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaPreTokenGenerationPostRequest} [cognitoLambdaPreTokenGenerationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPreTokenGenerationPost(cognitoLambdaPreTokenGenerationPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaPreTokenGenerationPost(cognitoLambdaPreTokenGenerationPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaPreTokenGenerationPostRequest} [cognitoLambdaPreTokenGenerationPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaTokenGenerationPost(cognitoLambdaPreTokenGenerationPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaTokenGenerationPost(cognitoLambdaPreTokenGenerationPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaMigrateUserPostRequest} [cognitoLambdaMigrateUserPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaUserMigrationPost(cognitoLambdaMigrateUserPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaUserMigrationPost(cognitoLambdaMigrateUserPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaVerifyAuthChallengePostRequest} [cognitoLambdaVerifyAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaVerifyAuthChallengePost(cognitoLambdaVerifyAuthChallengePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaVerifyAuthChallengePost(cognitoLambdaVerifyAuthChallengePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {CognitoLambdaVerifyAuthChallengePostRequest} [cognitoLambdaVerifyAuthChallengePostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaVerifyAuthChallengeResponsePost(cognitoLambdaVerifyAuthChallengePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cognitoLambdaVerifyAuthChallengeResponsePost(cognitoLambdaVerifyAuthChallengePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CognitoLambdaApi - factory interface
 * @export
 */
export const CognitoLambdaApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CognitoLambdaApiFp(configuration);
    return {
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaCreateAuthChallengePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaCreateAuthChallengePost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaCreateAuthChallengePost(requestParameters.cognitoLambdaCreateAuthChallengePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaCustomEmailSenderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaCustomEmailSenderPost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaCustomEmailSenderPost(requestParameters.cognitoLambdaCustomEmailSenderPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaDefineAuthChallengePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaDefineAuthChallengePost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaDefineAuthChallengePost(requestParameters.cognitoLambdaDefineAuthChallengePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaMigrateUserPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaMigrateUserPost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaMigrateUserPost(requestParameters.cognitoLambdaMigrateUserPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaPostConfirmationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPostConfirmationPost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaPostConfirmationPost(requestParameters.cognitoLambdaPostConfirmationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaPreSignUpPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPreSignUpPost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaPreSignUpPost(requestParameters.cognitoLambdaPreSignUpPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaPreTokenGenerationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaPreTokenGenerationPost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaPreTokenGenerationPost(requestParameters.cognitoLambdaPreTokenGenerationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaTokenGenerationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaTokenGenerationPost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaTokenGenerationPost(requestParameters.cognitoLambdaPreTokenGenerationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaUserMigrationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaUserMigrationPost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaUserMigrationPost(requestParameters.cognitoLambdaMigrateUserPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaVerifyAuthChallengePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaVerifyAuthChallengePost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaVerifyAuthChallengePost(requestParameters.cognitoLambdaVerifyAuthChallengePostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CognitoLambdaApiCognitoLambdaVerifyAuthChallengeResponsePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cognitoLambdaVerifyAuthChallengeResponsePost(requestParameters = {}, options) {
            return localVarFp.cognitoLambdaVerifyAuthChallengeResponsePost(requestParameters.cognitoLambdaVerifyAuthChallengePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CognitoLambdaApi - object-oriented interface
 * @export
 * @class CognitoLambdaApi
 * @extends {BaseAPI}
 */
export class CognitoLambdaApi extends BaseAPI {
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaCreateAuthChallengePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaCreateAuthChallengePost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaCreateAuthChallengePost(requestParameters.cognitoLambdaCreateAuthChallengePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaCustomEmailSenderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaCustomEmailSenderPost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaCustomEmailSenderPost(requestParameters.cognitoLambdaCustomEmailSenderPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaDefineAuthChallengePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaDefineAuthChallengePost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaDefineAuthChallengePost(requestParameters.cognitoLambdaDefineAuthChallengePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaMigrateUserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaMigrateUserPost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaMigrateUserPost(requestParameters.cognitoLambdaMigrateUserPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaPostConfirmationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaPostConfirmationPost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaPostConfirmationPost(requestParameters.cognitoLambdaPostConfirmationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaPreSignUpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaPreSignUpPost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaPreSignUpPost(requestParameters.cognitoLambdaPreSignUpPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaPreTokenGenerationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaPreTokenGenerationPost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaPreTokenGenerationPost(requestParameters.cognitoLambdaPreTokenGenerationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaTokenGenerationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaTokenGenerationPost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaTokenGenerationPost(requestParameters.cognitoLambdaPreTokenGenerationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaUserMigrationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaUserMigrationPost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaUserMigrationPost(requestParameters.cognitoLambdaMigrateUserPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaVerifyAuthChallengePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaVerifyAuthChallengePost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaVerifyAuthChallengePost(requestParameters.cognitoLambdaVerifyAuthChallengePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CognitoLambdaApiCognitoLambdaVerifyAuthChallengeResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CognitoLambdaApi
     */
    cognitoLambdaVerifyAuthChallengeResponsePost(requestParameters = {}, options) {
        return CognitoLambdaApiFp(this.configuration).cognitoLambdaVerifyAuthChallengeResponsePost(requestParameters.cognitoLambdaVerifyAuthChallengePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CronApi - axios parameter creator
 * @export
 */
export const CronApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [CronJob] set users with a processing payment verification status to unverified again
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openPendingPaymentVerificationPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/open-pending-payment-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CronApi - functional programming interface
 * @export
 */
export const CronApiFp = function (configuration) {
    const localVarAxiosParamCreator = CronApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [CronJob] set users with a processing payment verification status to unverified again
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openPendingPaymentVerificationPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.openPendingPaymentVerificationPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CronApi - factory interface
 * @export
 */
export const CronApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CronApiFp(configuration);
    return {
        /**
         *
         * @summary [CronJob] set users with a processing payment verification status to unverified again
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openPendingPaymentVerificationPost(options) {
            return localVarFp.openPendingPaymentVerificationPost(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CronApi - object-oriented interface
 * @export
 * @class CronApi
 * @extends {BaseAPI}
 */
export class CronApi extends BaseAPI {
    /**
     *
     * @summary [CronJob] set users with a processing payment verification status to unverified again
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CronApi
     */
    openPendingPaymentVerificationPost(options) {
        return CronApiFp(this.configuration).openPendingPaymentVerificationPost(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalUsersApi - axios parameter creator
 * @export
 */
export const InternalUsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [internal] get user accounts created in the last month.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersRecentGet: (xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('internalUsersRecentGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/internal/users/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [internal] Decrypts the cognito reset password token and raises the message to proper queue to trigger the email
         * @param {string} xPlatformKey Select the platform.
         * @param {InternalUsersResetPasswordPostRequest} [internalUsersResetPasswordPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersResetPasswordPost: (xPlatformKey, internalUsersResetPasswordPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('internalUsersResetPasswordPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/internal/users/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(internalUsersResetPasswordPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [internal] Provides details about a single user
         * @param {string} userId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersUserIdGet: (userId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('internalUsersUserIdGet', 'userId', userId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('internalUsersUserIdGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/internal/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalUsersApi - functional programming interface
 * @export
 */
export const InternalUsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalUsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [internal] get user accounts created in the last month.
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersRecentGet(xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalUsersRecentGet(xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [internal] Decrypts the cognito reset password token and raises the message to proper queue to trigger the email
         * @param {string} xPlatformKey Select the platform.
         * @param {InternalUsersResetPasswordPostRequest} [internalUsersResetPasswordPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersResetPasswordPost(xPlatformKey, internalUsersResetPasswordPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalUsersResetPasswordPost(xPlatformKey, internalUsersResetPasswordPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [internal] Provides details about a single user
         * @param {string} userId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersUserIdGet(userId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalUsersUserIdGet(userId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalUsersApi - factory interface
 * @export
 */
export const InternalUsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalUsersApiFp(configuration);
    return {
        /**
         *
         * @summary [internal] get user accounts created in the last month.
         * @param {InternalUsersApiInternalUsersRecentGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersRecentGet(requestParameters, options) {
            return localVarFp.internalUsersRecentGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [internal] Decrypts the cognito reset password token and raises the message to proper queue to trigger the email
         * @param {InternalUsersApiInternalUsersResetPasswordPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersResetPasswordPost(requestParameters, options) {
            return localVarFp.internalUsersResetPasswordPost(requestParameters.xPlatformKey, requestParameters.internalUsersResetPasswordPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [internal] Provides details about a single user
         * @param {InternalUsersApiInternalUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalUsersUserIdGet(requestParameters, options) {
            return localVarFp.internalUsersUserIdGet(requestParameters.userId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalUsersApi - object-oriented interface
 * @export
 * @class InternalUsersApi
 * @extends {BaseAPI}
 */
export class InternalUsersApi extends BaseAPI {
    /**
     *
     * @summary [internal] get user accounts created in the last month.
     * @param {InternalUsersApiInternalUsersRecentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalUsersApi
     */
    internalUsersRecentGet(requestParameters, options) {
        return InternalUsersApiFp(this.configuration).internalUsersRecentGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [internal] Decrypts the cognito reset password token and raises the message to proper queue to trigger the email
     * @param {InternalUsersApiInternalUsersResetPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalUsersApi
     */
    internalUsersResetPasswordPost(requestParameters, options) {
        return InternalUsersApiFp(this.configuration).internalUsersResetPasswordPost(requestParameters.xPlatformKey, requestParameters.internalUsersResetPasswordPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [internal] Provides details about a single user
     * @param {InternalUsersApiInternalUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalUsersApi
     */
    internalUsersUserIdGet(requestParameters, options) {
        return InternalUsersApiFp(this.configuration).internalUsersUserIdGet(requestParameters.userId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LfcApi - axios parameter creator
 * @export
 */
export const LfcApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lfcEmailGet: (email, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('lfcEmailGet', 'email', email);
            const localVarPath = `/lfc/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LfcApi - functional programming interface
 * @export
 */
export const LfcApiFp = function (configuration) {
    const localVarAxiosParamCreator = LfcApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lfcEmailGet(email, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.lfcEmailGet(email, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LfcApi - factory interface
 * @export
 */
export const LfcApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LfcApiFp(configuration);
    return {
        /**
         *
         * @param {LfcApiLfcEmailGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lfcEmailGet(requestParameters, options) {
            return localVarFp.lfcEmailGet(requestParameters.email, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LfcApi - object-oriented interface
 * @export
 * @class LfcApi
 * @extends {BaseAPI}
 */
export class LfcApi extends BaseAPI {
    /**
     *
     * @param {LfcApiLfcEmailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LfcApi
     */
    lfcEmailGet(requestParameters, options) {
        return LfcApiFp(this.configuration).lfcEmailGet(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returns all the permissions that exist within the service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPermissionsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/access/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Returns all the roles, including the permissions allowed for that role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/access/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete role
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessRolesIdDelete', 'id', id);
            const localVarPath = `/access/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Return role by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessRolesIdGet', 'id', id);
            const localVarPath = `/access/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update role by id
         * @param {string} id
         * @param {AccessRolesIdPatchRequest} [accessRolesIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdPatch: (id, accessRolesIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('accessRolesIdPatch', 'id', id);
            const localVarPath = `/access/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessRolesIdPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a role
         * @param {AccessRolesPostRequest} [accessRolesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesPost: (accessRolesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/access/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessRolesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Returns all the permissions that exist within the service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPermissionsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessPermissionsGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Returns all the roles, including the permissions allowed for that role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessRolesGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete role
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessRolesIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Return role by id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessRolesIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update role by id
         * @param {string} id
         * @param {AccessRolesIdPatchRequest} [accessRolesIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdPatch(id, accessRolesIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessRolesIdPatch(id, accessRolesIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a role
         * @param {AccessRolesPostRequest} [accessRolesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesPost(accessRolesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.accessRolesPost(accessRolesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PermissionsApiFp(configuration);
    return {
        /**
         *
         * @summary Returns all the permissions that exist within the service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessPermissionsGet(options) {
            return localVarFp.accessPermissionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Returns all the roles, including the permissions allowed for that role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesGet(options) {
            return localVarFp.accessRolesGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete role
         * @param {PermissionsApiAccessRolesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdDelete(requestParameters, options) {
            return localVarFp.accessRolesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return role by id
         * @param {PermissionsApiAccessRolesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdGet(requestParameters, options) {
            return localVarFp.accessRolesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update role by id
         * @param {PermissionsApiAccessRolesIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesIdPatch(requestParameters, options) {
            return localVarFp.accessRolesIdPatch(requestParameters.id, requestParameters.accessRolesIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a role
         * @param {PermissionsApiAccessRolesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accessRolesPost(requestParameters = {}, options) {
            return localVarFp.accessRolesPost(requestParameters.accessRolesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     *
     * @summary Returns all the permissions that exist within the service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    accessPermissionsGet(options) {
        return PermissionsApiFp(this.configuration).accessPermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Returns all the roles, including the permissions allowed for that role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    accessRolesGet(options) {
        return PermissionsApiFp(this.configuration).accessRolesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete role
     * @param {PermissionsApiAccessRolesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    accessRolesIdDelete(requestParameters, options) {
        return PermissionsApiFp(this.configuration).accessRolesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Return role by id
     * @param {PermissionsApiAccessRolesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    accessRolesIdGet(requestParameters, options) {
        return PermissionsApiFp(this.configuration).accessRolesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update role by id
     * @param {PermissionsApiAccessRolesIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    accessRolesIdPatch(requestParameters, options) {
        return PermissionsApiFp(this.configuration).accessRolesIdPatch(requestParameters.id, requestParameters.accessRolesIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a role
     * @param {PermissionsApiAccessRolesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    accessRolesPost(requestParameters = {}, options) {
        return PermissionsApiFp(this.configuration).accessRolesPost(requestParameters.accessRolesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new session (a.k.a. logging in)
         * @param {string} [xPlatformKey]
         * @param {AuthPostRequest} [authPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPost: (xPlatformKey, authPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(authPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Refreshes a session by using the refresh token to issue a new access token, and  also renewing the current session\'s duration.
         * @param {string} xPlatformKey2 Select the platform.
         * @param {string} [xPlatformKey]
         * @param {RefreshPostRequest} [refreshPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPost: (xPlatformKey2, xPlatformKey, refreshPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey2' is not null or undefined
            assertParamExists('refreshPost', 'xPlatformKey2', xPlatformKey2);
            const localVarPath = `/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            if (xPlatformKey2 != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey2);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(refreshPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This used to be a HttpDelete request, but because we now have to send the refresh token in  the body, we can\'t use DELETE anymore because that doesn\'t allow for a request body. So instead  we pretend that logging out is like \"updating\" the session\'s status to \'deleted\'.
         * @summary Logout: deletes the current session if instructed to do so in the request.
         * @param {SessionsCurrentPatchRequest} [sessionsCurrentPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsCurrentPatch: (sessionsCurrentPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sessions/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sessionsCurrentPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = SessionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new session (a.k.a. logging in)
         * @param {string} [xPlatformKey]
         * @param {AuthPostRequest} [authPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPost(xPlatformKey, authPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authPost(xPlatformKey, authPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Refreshes a session by using the refresh token to issue a new access token, and  also renewing the current session\'s duration.
         * @param {string} xPlatformKey2 Select the platform.
         * @param {string} [xPlatformKey]
         * @param {RefreshPostRequest} [refreshPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPost(xPlatformKey2, xPlatformKey, refreshPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.refreshPost(xPlatformKey2, xPlatformKey, refreshPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * This used to be a HttpDelete request, but because we now have to send the refresh token in  the body, we can\'t use DELETE anymore because that doesn\'t allow for a request body. So instead  we pretend that logging out is like \"updating\" the session\'s status to \'deleted\'.
         * @summary Logout: deletes the current session if instructed to do so in the request.
         * @param {SessionsCurrentPatchRequest} [sessionsCurrentPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsCurrentPatch(sessionsCurrentPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sessionsCurrentPatch(sessionsCurrentPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SessionsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new session (a.k.a. logging in)
         * @param {SessionsApiAuthPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPost(requestParameters = {}, options) {
            return localVarFp.authPost(requestParameters.xPlatformKey, requestParameters.authPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Refreshes a session by using the refresh token to issue a new access token, and  also renewing the current session\'s duration.
         * @param {SessionsApiRefreshPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPost(requestParameters, options) {
            return localVarFp.refreshPost(requestParameters.xPlatformKey2, requestParameters.xPlatformKey, requestParameters.refreshPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This used to be a HttpDelete request, but because we now have to send the refresh token in  the body, we can\'t use DELETE anymore because that doesn\'t allow for a request body. So instead  we pretend that logging out is like \"updating\" the session\'s status to \'deleted\'.
         * @summary Logout: deletes the current session if instructed to do so in the request.
         * @param {SessionsApiSessionsCurrentPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsCurrentPatch(requestParameters = {}, options) {
            return localVarFp.sessionsCurrentPatch(requestParameters.sessionsCurrentPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
    /**
     *
     * @summary Create a new session (a.k.a. logging in)
     * @param {SessionsApiAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    authPost(requestParameters = {}, options) {
        return SessionsApiFp(this.configuration).authPost(requestParameters.xPlatformKey, requestParameters.authPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Refreshes a session by using the refresh token to issue a new access token, and  also renewing the current session\'s duration.
     * @param {SessionsApiRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    refreshPost(requestParameters, options) {
        return SessionsApiFp(this.configuration).refreshPost(requestParameters.xPlatformKey2, requestParameters.xPlatformKey, requestParameters.refreshPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This used to be a HttpDelete request, but because we now have to send the refresh token in  the body, we can\'t use DELETE anymore because that doesn\'t allow for a request body. So instead  we pretend that logging out is like \"updating\" the session\'s status to \'deleted\'.
     * @summary Logout: deletes the current session if instructed to do so in the request.
     * @param {SessionsApiSessionsCurrentPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    sessionsCurrentPatch(requestParameters = {}, options) {
        return SessionsApiFp(this.configuration).sessionsCurrentPatch(requestParameters.sessionsCurrentPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserPermissionsApi - axios parameter creator
 * @export
 */
export const UserPermissionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPermissionsEmailGet: (email, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('usersPermissionsEmailGet', 'email', email);
            const localVarPath = `/users/permissions/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserPermissionsApi - functional programming interface
 * @export
 */
export const UserPermissionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserPermissionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPermissionsEmailGet(email, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersPermissionsEmailGet(email, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UserPermissionsApi - factory interface
 * @export
 */
export const UserPermissionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserPermissionsApiFp(configuration);
    return {
        /**
         *
         * @param {UserPermissionsApiUsersPermissionsEmailGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPermissionsEmailGet(requestParameters, options) {
            return localVarFp.usersPermissionsEmailGet(requestParameters.email, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserPermissionsApi - object-oriented interface
 * @export
 * @class UserPermissionsApi
 * @extends {BaseAPI}
 */
export class UserPermissionsApi extends BaseAPI {
    /**
     *
     * @param {UserPermissionsApiUsersPermissionsEmailGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPermissionsApi
     */
    usersPermissionsEmailGet(requestParameters, options) {
        return UserPermissionsApiFp(this.configuration).usersPermissionsEmailGet(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary reset password for user
         * @param {string} xPlatformKey Select the platform.
         * @param {UsersPasswordResetPostRequest} [usersPasswordResetPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetPost: (xPlatformKey, usersPasswordResetPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('usersPasswordResetPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/users/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(usersPasswordResetPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Checks if a password reset token is still valid, does not use the token.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTokenGet: (token, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/password/reset/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary request a password reset token
         * @param {string} xPlatformKey Select the platform.
         * @param {UsersPasswordResetTokenPostRequest} [usersPasswordResetTokenPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTokenPost: (xPlatformKey, usersPasswordResetTokenPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('usersPasswordResetTokenPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/users/password/reset/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(usersPasswordResetTokenPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersVerificationPaymentPendingPut: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/verification/payment/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary reset password for user
         * @param {string} xPlatformKey Select the platform.
         * @param {UsersPasswordResetPostRequest} [usersPasswordResetPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetPost(xPlatformKey, usersPasswordResetPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersPasswordResetPost(xPlatformKey, usersPasswordResetPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Checks if a password reset token is still valid, does not use the token.
         * @param {string} [token]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTokenGet(token, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersPasswordResetTokenGet(token, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary request a password reset token
         * @param {string} xPlatformKey Select the platform.
         * @param {UsersPasswordResetTokenPostRequest} [usersPasswordResetTokenPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTokenPost(xPlatformKey, usersPasswordResetTokenPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersPasswordResetTokenPost(xPlatformKey, usersPasswordResetTokenPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersVerificationPaymentPendingPut(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usersVerificationPaymentPendingPut(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UsersApiFp(configuration);
    return {
        /**
         *
         * @summary reset password for user
         * @param {UsersApiUsersPasswordResetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetPost(requestParameters, options) {
            return localVarFp.usersPasswordResetPost(requestParameters.xPlatformKey, requestParameters.usersPasswordResetPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Checks if a password reset token is still valid, does not use the token.
         * @param {UsersApiUsersPasswordResetTokenGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTokenGet(requestParameters = {}, options) {
            return localVarFp.usersPasswordResetTokenGet(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary request a password reset token
         * @param {UsersApiUsersPasswordResetTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPasswordResetTokenPost(requestParameters, options) {
            return localVarFp.usersPasswordResetTokenPost(requestParameters.xPlatformKey, requestParameters.usersPasswordResetTokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersVerificationPaymentPendingPut(options) {
            return localVarFp.usersVerificationPaymentPendingPut(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     *
     * @summary reset password for user
     * @param {UsersApiUsersPasswordResetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersPasswordResetPost(requestParameters, options) {
        return UsersApiFp(this.configuration).usersPasswordResetPost(requestParameters.xPlatformKey, requestParameters.usersPasswordResetPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Checks if a password reset token is still valid, does not use the token.
     * @param {UsersApiUsersPasswordResetTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersPasswordResetTokenGet(requestParameters = {}, options) {
        return UsersApiFp(this.configuration).usersPasswordResetTokenGet(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary request a password reset token
     * @param {UsersApiUsersPasswordResetTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersPasswordResetTokenPost(requestParameters, options) {
        return UsersApiFp(this.configuration).usersPasswordResetTokenPost(requestParameters.xPlatformKey, requestParameters.usersPasswordResetTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    usersVerificationPaymentPendingPut(options) {
        return UsersApiFp(this.configuration).usersVerificationPaymentPendingPut(options).then((request) => request(this.axios, this.basePath));
    }
}
